import React, { PropsWithChildren } from 'react';
import styles from './WrapperButton.module.scss';

const WrapperButton = (props: PropsWithChildren) => {
  return <div className={styles.wrapperButton}>{props.children}</div>;
};

export default WrapperButton;
